export function AutoUnsubscribe(constructor) {
  const originalFunc = constructor.prototype.ngOnDestroy;
  constructor.prototype.ngOnDestroy = function () {
    for (const prop in this) {
      const property = this[prop];
      if (property && (typeof property.unsubscribe === 'function')) {
        property.unsubscribe();
      }
    }
    if (originalFunc) {
      originalFunc.apply(this, arguments);
    }
  };
}
